import React from 'react'
import { Button, Color, Spinner } from '@gousto-internal/citrus-react'

import type { LoggedOutBoxSummaryCta } from '../types'

type PanelContinueButtonProps = {
  cta: LoggedOutBoxSummaryCta
  testId: string
  type?: 'button' | 'submit'
  onClick?: () => void
}

/**
 * Shared full-width continue/submit CTA for the logged-out box-summary panels.
 * Centralises the disabled-while-pending guard and the pending spinner so every
 * panel (postcode, delivery, and future panels) renders an identical affordance.
 */
export const PanelContinueButton = ({
  cta,
  testId,
  type = 'button',
  onClick,
}: PanelContinueButtonProps) => (
  <Button
    type={type}
    width="100%"
    onClick={onClick}
    disabled={cta.isDisabled || cta.isPending}
    aria-busy={cta.isPending}
    data-testid={testId}
  >
    {cta.isPending ? <Spinner color={Color.White} size={6} /> : cta.label}
  </Button>
)
